// @flow
import { LabelText, RangeSliderContainer, SetValueContainer, Slider, SliderColorBar, SliderContainer } from './styles';

import { noop } from 'lodash/fp';
import * as React from 'react';

type Props = {
    defaultValue: number,
    disabled: boolean,
    maxValue?: number,
    minSnapPoint: number,
    minSnapPointThreshold?: number,
    minValue?: number,
    setValue: noop,
    step?: number,
    value?: number,
    valueMap: Map<number, string>,
    valuePostfix?: string
};

type State = {
    displayValue?: string,
    value: number
};

export default class RangeSlider extends React.Component<Props, State> {
    static defaultState: {
        valueMap: Map<*, *>
    } = {
        valueMap: new Map()
    };

    componentWillMount() {
        const { maxValue = 100, defaultValue, valuePostfix = '' } = this.props;

        this.setState({
            value: defaultValue !== undefined ? defaultValue : maxValue / 2,
            displayValue: defaultValue < 30 ? 'OFF' : `${defaultValue}${valuePostfix}`
        });
    }

    handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
        let value = parseInt(event.currentTarget.value, 10);
        const {
            minSnapPoint,
            minSnapPointThreshold = minSnapPoint,
            minValue = 0,
            valueMap,
            valuePostfix = ''
        } = this.props;

        if (minSnapPoint && value < minSnapPoint) {
            value = value < minSnapPointThreshold ? minValue : minSnapPoint;
            const nextDisplayValue = valueMap.get(value) || `${value}${valuePostfix}`;

            this.setState({
                value,
                displayValue: nextDisplayValue
            });

            this.props.setValue(value);

            return;
        }

        this.setState({
            value,
            displayValue: `${value}${valuePostfix}`
        });

        this.props.setValue(value);
    };

    render() {
        const { minValue = 0, maxValue = 100, step = 1, disabled } = this.props;

        return (
            <RangeSliderContainer>
                <SliderContainer>
                    <Slider
                        aria-label="range slider"
                        disabled={disabled}
                        max={maxValue}
                        min={minValue}
                        onChange={this.handleChange}
                        step={step}
                        type="range"
                        value={this.state.value}
                    />
                    <SliderColorBar />
                    <SliderColorBar disabled={disabled} highlightProgress style={{ width: `${this.state.value}%` }} />
                </SliderContainer>
                <SetValueContainer disabled={disabled}>
                    <LabelText>set to</LabelText>
                    <div>{this.state.displayValue}</div>
                </SetValueContainer>
            </RangeSliderContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/range-slider/index.js